import { InfoOutlined, KeyboardArrowLeft } from "@mui/icons-material";
import { Box, styled, Tooltip } from "@mui/material";
import useCurrentPath from "../hooks/useCurrentPath";
import { Link } from "react-router-dom";
import { COLORS } from "../../ui/Theme";

const Pathname = () => {
  const { route1, route2, route3 } = useCurrentPath();

  const Typography = styled("p")({
    ":hover": { color: COLORS.BLUE },
    fontSize: "14px",
    fontWeight: !route2 && 700,
  });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: "#9e9e9e",
          gap: 1,
        }}
      >
        <Link
          to={
            route1.route === "dashboard"
              ? "/dashboard"
              : route1.route === "recommended"
              ? "recommended"
              : "#"
          }
          style={{
            cursor:
              route1.route !== "dashboard" && route1.route !== "recommended"
                ? "not-allowed"
                : "pointer",
          }}
        >
          <Typography
            sx={{
              ":hover": { color: COLORS.BLUE },
              fontSize: "14px",
              fontWeight: !route2 && 700,
            }}
          >
            {route1?.label}
          </Typography>
        </Link>
        {route2 && <KeyboardArrowLeft />}

        {route2 && (
          <>
            <Link
              to={`${route1.route}/${route2.route}`}
              style={{ fontSize: "14px", fontWeight: !route3 && 700 }}
            >
              <Typography sx={{ ":hover": { color: COLORS.BLUE } }}>
                {route2.label}
              </Typography>
            </Link>
            <Tooltip title={route2.description} arrow placement="left-start">
              <InfoOutlined sx={{ width: "15px" }} />
            </Tooltip>
          </>
        )}
        {route3 && <KeyboardArrowLeft />}

        {route3 && (
          <>
            <Link
              to={`${route1.route}/${route2.route}/${route3.route}`}
              style={{ fontSize: "14px", fontWeight: 700 }}
            >
              {route3.label}
            </Link>

            <Tooltip title={route3.description} arrow placement="left-start">
              <InfoOutlined sx={{ width: "15px" }} />
            </Tooltip>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Pathname;
